export default __webpack_public_path__ + "static/media/graphql.91f50adf.png";